import LocationDataGrid from './LocationDataGrid';

export default LocationDataGrid;
export * from './LocationDataGrid';
